export function buildStableHash(value: unknown) {
  return hashString(stableStringify(value));
}

function stableStringify(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }

  if (value && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, entryValue]) => entryValue !== undefined && typeof entryValue !== 'function')
      .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey));

    return `{${entries.map(([key, entryValue]) => `${JSON.stringify(key)}:${stableStringify(entryValue)}`).join(',')}}`;
  }

  return JSON.stringify(value ?? null);
}

function hashString(value: string) {
  let firstHash = 5381;
  let secondHash = 52711;

  for (let index = 0; index < value.length; index += 1) {
    const charCode = value.charCodeAt(index);

    firstHash = (firstHash * 33) ^ charCode;
    secondHash = (secondHash * 33) ^ (charCode + index);
  }

  return `${toHex(firstHash)}${toHex(secondHash)}`;
}

function toHex(value: number) {
  return (value >>> 0).toString(16).padStart(8, '0');
}
